import {
  listProducts,
  productPriceByCity,
  productPrices,
  templateHet,
  updateProductPrices,
  uploadBulkPrice,
  subUserProductPrices,
  updateSubUserProductPrices,
  getSubUserByRegistrationId,
  updateSubUserProductPricesBySubUserId,
  uploadBulkPriceSubUser,
  basePrice,
} from '../../utils/api';
import { FAILED, LOADING, SUCCESS, CLEAR_MESSAGE, RESET } from './constants';

export const fetchBaseGeneralPrices = () => {
  return async (dispatch) => {
    const key = 'BaseGeneralPrices';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await basePrice();
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchProducts = (categoryId) => {
  return async (dispatch) => {
    const key = 'Products';
    dispatch(successAction(false, 'SubmitProductPrices'));
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listProducts(categoryId);

      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchProductPriceLists = (params = {}) => {
  return async (dispatch, getState) => {
    const { totalPage } = getState().prices.dataProductPriceLists.meta;
    let dataList = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }
    const key = 'ProductPriceLists';
    try {
      if (params?.page !== 1 && params?.page !== '1') {
        // dispatch(successAction({ data : [] }, key));
        dataList = getState().prices.dataProductPriceLists.data;
      }
      dispatch(loadingAction(false, 'SubmitProductPrices'));
      dispatch(loadingAction(true, key));
      const requestParams = {
        ...params,
        cityId: JSON.stringify(params.cityId),
        size: 100,
      };

      let { data, meta } = await productPrices(requestParams);
      dispatch(successAction({ data: [...dataList, ...data], meta }, key));
      dispatch(successAction(false, 'SubmitProductPrices'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchSubUserProductPriceLists = (params = {}) => {
  return async (dispatch, getState) => {
    const { totalPage } = getState().prices.dataSubUserProductPriceLists.meta;
    let dataList = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }
    const key = 'SubUserProductPriceLists';
    try {
      if (params?.page !== 1 && params?.page !== '1') {
        // dispatch(successAction({ data : [] }, key));
        dataList = getState().prices.dataSubUserProductPriceLists.data;
      }
      dispatch(loadingAction(false, 'SubmitSubUserProductPrices'));
      dispatch(loadingAction(true, key));
      const requestParams = {
        ...params,
        cityId: params.cityId,
        size: 100,
      };

      let { data, meta } = await subUserProductPrices(requestParams);
      dispatch(successAction({ data: [...dataList, ...data], meta }, key));
      dispatch(successAction(false, 'SubmitSubUserProductPrices'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function setAturHargaFilter(filter) {
  return async (dispatch) => {
    dispatch(successAction(filter, 'Filter'));
  };
}

export function setAturHargaSubUserFilter(filter) {
  return async (dispatch) => {
    dispatch(successAction(filter, 'SubUserFilter'));
  };
}

export const fetchProductPrices = (categoryId, cityId) => {
  return async (dispatch) => {
    const key = 'ProductPrices';
    dispatch(successAction(false, 'SubmitProductPrices'));
    dispatch(loadingAction(true, key));
    try {
      let data = {};

      if (cityId) {
        const { data: cityPrices } = await productPriceByCity(categoryId, cityId);
        data = cityPrices;
      } else {
        const { data: dataProducts } = await listProducts(categoryId);
        let productPrices = dataProducts.map((product) => ({
          productName: product.productName,
          productId: product.productId,
          productPrice: null,
          productModal: null,
        }));
        data = { products: productPrices };
      }
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitProductPrices = (data = {}) => {
  return async (dispatch) => {
    const key = 'SubmitProductPrices';
    dispatch(loadingAction(true, key));
    try {
      data = {
        region: data.region,
        provinceId: data.provinceId,
        cityId: data.cityId,
        products: [
          {
            productId: '7d80fe3d-d361-4193-ad67-730aa1ced4a6',
            productMinPrice: data.hargaJualMin,
            productMaxPrice: data.hargaJualMax,
            productModal: '',
          },
        ],
      };
      const res = await updateProductPrices(data);
      dispatch(successAction(res, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitSubUserProductPrices = (data = {}) => {
  return async (dispatch) => {
    const key = 'SubmitSubUserProductPrices';
    dispatch(loadingAction(true, key));
    try {
      data = {
        regional: data.region,
        provinceId: data.provinceId,
        cityId: data.cityId,
        districtId: data.districtId,
        villageId: data.villageId,
        minPrice: +data.hargaJualMin,
        maxPrice: +data.hargaJualMax,
      };
      await updateSubUserProductPrices(data);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const editSubUserProductPricesBySubUserId = (data = {}) => {
  return async (dispatch) => {
    const key = 'EditSubUserProductPricesBySubUserId';
    dispatch(loadingAction(true, key));
    try {
      data = {
        subUserId: data.subUserId,
        minPrice: +data.minPrice,
        maxPrice: +data.maxPrice,
      };
      await updateSubUserProductPricesBySubUserId(data);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchTemplateHet = (region = '', provinceId = '', cityId = '') => {
  return async (dispatch) => {
    const key = 'TemplateHet';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await templateHet(region, provinceId, cityId);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitUploadUpdatePrice = (file = {}, callback = () => { }) => {
  return async (dispatch) => {
    const key = 'UploadUpdatePrice';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const data = await uploadBulkPrice(file.file);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitUploadUpdatePriceSubUser = (file = {}, callback = () => { }) => {
  return async (dispatch) => {
    const key = 'UploadUpdatePriceSubUser';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const { data } = await uploadBulkPriceSubUser(file.file);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const searchSubUserByRegistrationId = (registrationId = '') => {
  return async (dispatch) => {
    const key = 'SearchSubUserByRegistrationId';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await getSubUserByRegistrationId(registrationId);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

export function clearMessage(key) {
  return async (dispatch) => {
    dispatch({ key, type: CLEAR_MESSAGE });
  };
}

export const resetState = (key) => {
  return async (dispatch) => {
    dispatch({ key, type: RESET });
  };
};
